var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"index"}},[_c('headertop',{attrs:{"show":_vm.show}}),_c('sidebar'),_c('top'),_c('navbar'),_c('cate',{on:{"scollTop":_vm.scollTop}}),_c('router-view'),_c('foot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }